import { AccessInternetTypeValue } from './access';

export const NetworkItemType = {
    Network: 'NETWORK',
    Host: 'HOST',
} as const;

export const NetworkItemTypeList = Object.values(NetworkItemType);

export const NetworkItemKeys = {
    networks: 'networks',
    hosts: 'hosts',
} as const;

export const NetworkItemKeysList = Object.keys(NetworkItemKeys);

export type DependentItemsType = 'userGroup' | 'host' | 'network';

export type DependentItems = Partial<
    Record<
        DependentItemsType,
        { id: string; name: string; internetAccess: AccessInternetTypeValue }[]
    >
>;
